import * as React from 'react';
import { Login } from './components/Login';
import {Signup} from './components/Signup';
import {Error} from './components/Error';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import { Navigate } from 'react-router-dom';


function App() {
  return (
    <div className='App'>
      <Routes>
        <Route path="/" element={<Navigate to="/login"/>} />
        <Route path="/login" element={<Login/> }/>
        <Route path="/home" element={<Home/>}/>
        <Route path="/signup" element={<Signup/>} />
        <Route element={<Error/>} />
      </Routes>
    </div>
  );
}

export default App;
